/**
 * Gravity Forms: set input `type` and `autocomplete` (WCAG 1.3.5 Identify Input Purpose)
 *
 * Matching uses, in order: GF field wrapper classes (gfield--type-*, gfield--input-type-*),
 * the sub-input wrapper classes (name_first, address_city, ...), then the input's
 * label/name text as a fallback. Existing `autocomplete` values are never overridden.
 * Only `type` is changed when the input is a plain text input.
 */
(function () {
	"use strict";

	// [regex tested against sub-input class / label / name, autocomplete token, optional type]
	var RULES = [
		[/(^|[\s_-])(email|e-mail)/i, "email", "email"],
		[/(^|[\s_-])(phone|tel|mobile)/i, "tel", "tel"],
		[/name_first|first[\s_-]?name/i, "given-name"],
		[/name_last|last[\s_-]?name|surname/i, "family-name"],
		[/name_middle|middle[\s_-]?name/i, "additional-name"],
		[/name_prefix/i, "honorific-prefix"],
		[/name_suffix/i, "honorific-suffix"],
		[/address_line_1|street[\s_-]?address/i, "address-line1"],
		[/address_line_2/i, "address-line2"],
		[/address_city|(^|[\s_-])city/i, "address-level2"],
		[/address_state|(^|[\s_-])(state|province|region)/i, "address-level1"],
		[/address_zip|zip|postal/i, "postal-code"],
		[/address_country|(^|[\s_-])country/i, "country-name"],
		[/(^|[\s_-])(company|organi[sz]ation)/i, "organization"],
		[/(^|[\s_-])(website|url)/i, "url", "url"],
		[/(^|[\s_-])(full[\s_-]?name|your[\s_-]?name|name)$/i, "name"],
	];

	function labelText(input) {
		var text = "";
		if (input.id) {
			var l = document.querySelector('label[for="' + input.id + '"]');
			if (l) text = l.textContent;
		}
		if (!text) {
			var field = input.closest(".gfield");
			var fl = field && field.querySelector(".gfield_label");
			if (fl) text = fl.textContent;
		}
		return (text || "").replace(/\s*\(?required\)?\s*$/i, "").trim();
	}

	function hints(input) {
		var wrap = input.closest(
			'.ginput_container, [class*="name_"], [class*="address_"]',
		);
		var field = input.closest(".gfield");
		var sub = wrap ? wrap.className : "";
		var type = field
			? field.className.match(/gfield--(?:input-)?type-(\w+)/g) || []
			: [];
		return [sub, type.join(" "), labelText(input), input.name || ""];
	}

	function apply(input) {
		if (input.getAttribute("autocomplete")) return;
		var h = hints(input);
		for (var i = 0; i < h.length; i++) {
			if (!h[i]) continue;
			for (var j = 0; j < RULES.length; j++) {
				if (RULES[j][0].test(h[i])) {
					input.setAttribute("autocomplete", RULES[j][1]);
					if (RULES[j][2] && input.type === "text")
						input.type = RULES[j][2];
					return;
				}
			}
		}
	}

	function run(root) {
		(root || document)
			.querySelectorAll(".gform_wrapper input, .gform_wrapper select")
			.forEach(function (el) {
				if (
					/^(hidden|checkbox|radio|submit|button|file|password)$/.test(
						el.type,
					)
				)
					return;
				apply(el);
			});
	}

	function init() {
		run(document);
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}

	if (window.jQuery) {
		window.jQuery(document).on("gform_post_render", init);
	}

	document.addEventListener("gform/post_render", init);
})();
